import React from 'react'
import { useSelector } from 'react-redux'

import { FAVORITE_GAME_CATEGORY_SLUG } from '../../../../../containers/App/constants'
import { makeSelectIsLogged } from '../../../../../containers/MainLayout/selectors'
import useCategory from '../../../hooks/useCategory'
import { IconItem } from '../../IconItem'
import { generateFavoriteCategoryObject } from './utils'

interface Props {
  category?: string
  isSearching?: boolean
}

export default function IconFavorite({ category, isSearching }: Props) {
  const isLogged = useSelector(makeSelectIsLogged())
  const { changeCategory } = useCategory()
  const favorite = generateFavoriteCategoryObject()
  const isEnabled = !isSearching && category === FAVORITE_GAME_CATEGORY_SLUG
  const onClick = () => {
    changeCategory(FAVORITE_GAME_CATEGORY_SLUG)
  }

  return (
    <IconItem
      icon={favorite.icon}
      onClick={onClick}
      label={favorite.label}
      isEnabled={isEnabled}
      shouldRender={!!isLogged}
    />
  )
}
